export default __webpack_public_path__ + "media/images/icon_mobile_apps-a981aa2d6ac5085a02e7e548a4504871.png";